"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames5 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _mdiMaterialUi = require("mdi-material-ui");
var _styles = require("@material-ui/styles");
var _HtmlTooltip = _interopRequireDefault(require("../HtmlTooltip/HtmlTooltip"));
var _Divider = _interopRequireDefault(require("../Divider/Divider"));
var _CollapsibleItem = _interopRequireDefault(require("./CollapsibleItem.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CollapsibleItem = function CollapsibleItem(_ref) {
  var title = _ref.title,
    actions = _ref.actions,
    children = _ref.children,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? true : _ref$open,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? '' : _ref$error,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? '' : _ref$subtitle,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required;
  // HOOKS
  var theme = (0, _styles.useTheme)();
  var classes = (0, _CollapsibleItem.default)();

  // EVENTS

  var errorMessage = typeof error === 'string' ? error : null;
  var cssHeader = (0, _classnames5.default)(classes.visibleContainer, _defineProperty({}, classes.opened, open), _defineProperty({}, classes.closed, !open), _defineProperty({}, classes.clickable, !!onClick), _defineProperty({}, classes.error, Boolean(error) > 0));
  var handleClick = function handleClick() {
    if (onClick) {
      onClick();
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cssHeader
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    px: 2,
    display: "flex",
    justifyContent: "space-between",
    height: "100%",
    width: "100%",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.titleContainer,
    onClick: handleClick,
    role: "presentation"
  }, error && !open && /*#__PURE__*/_react.default.createElement(_core.Box, {
    mr: 2
  }, !errorMessage && /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Alert, {
    htmlColor: theme.palette.RED400
  }), errorMessage && /*#__PURE__*/_react.default.createElement(_HtmlTooltip.default, {
    interactive: true,
    placement: "top",
    title: /*#__PURE__*/_react.default.createElement(_core.Typography, {
      color: "primary"
    }, errorMessage)
  }, /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Alert, {
    htmlColor: theme.palette.RED400
  }))), /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.title
  }, title)), !open && subtitle && /*#__PURE__*/_react.default.createElement(_core.Box, {
    ml: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.subtitle
  }, subtitle)), !open && required && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Divider.default, {
    vertical: true,
    height: "20px"
  }), /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.required
  }, "Required")))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.actions
  }, actions))), /*#__PURE__*/_react.default.createElement(_core.Collapse, {
    in: open,
    timeout: 0
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: classes.contentsContainer
  }, children)));
};
CollapsibleItem.propTypes = {
  /** Determines if the item is open or closed */
  open: _propTypes.default.bool,
  /** The title to be showed in the header */
  title: _propTypes.default.string,
  /** The subtitle to be showed in the header */
  subtitle: _propTypes.default.string,
  /** The required label to be showed in the header */
  required: _propTypes.default.bool,
  /** A ReactNode to be rendered in the header item for handle actions */
  actions: _propTypes.default.element,
  /** Whether the item has an error.
  If a string is provided, it is displayed in a tooltip when the item is closed */
  error: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  /** A handler that is called when the user clicks the header.
  If not provided, then the header is not clickable */
  onClick: _propTypes.default.func
};
var _default = CollapsibleItem;
exports.default = _default;